<div class="alert alert-info" *ngIf="showBanner">
    {{ message }}
</div>
